class CompleteTheSet extends window.BAO.ProductForm {
  setupListeners () {
    super.setupListeners()
    if (!this.closeEl || !this.parentProductHandle) return
    this.listeners.add(this, 'click', this.handleClose.bind(this))
  }

  handleClose (event) {
    if (!event.target.closest(this.els.close.selector)) return
    this.hidden = true
    this.addProductHandleToStorage(this.parentProductHandle)
  }

  addProductHandleToStorage (productHandle) {
    const productHandleArray = this.storedProductHandleArray
    if (!productHandleArray.includes(productHandle)) {
      productHandleArray.push(productHandle)
    }
    const productHandlesString = productHandleArray.join('|')
    this.storage.setItem(this.storageKey, productHandlesString)
    this.updateCartAttributes({ [this.storageKey]: productHandlesString })

    /* Reset storage and cart attribute using: */
    // window.sessionStorage.setItem('complete-the-set', '')
    // window.BAO.Cart.updateCartAttributes({ 'complete-the-set': '' })
  }

  async updateCartAttributes (attributes) {
    const state = await window.BAO.Cart.updateCartAttributes(attributes)
    window.BAO.dispatchEvent(window.BAO.EVENTS.PUSH_CART.RERENDER, {
      items: state.items,
      state,
    })
  }

  get hidden () {
    return this.getAttribute(this.hiddenAttribute) === 'true'
  }

  set hidden (boolean) {
    this.setAttribute(this.hiddenAttribute, boolean.toString())
  }

  get hiddenAttribute () {
    return `aria-hidden`
  }

  get closeEl () {
    return this?.els?.close?.element
  }

  get storedProductHandleArray () {
    const productHandlesString = this.storage.getItem(this.storageKey)
    return productHandlesString ? productHandlesString.split('|') : []
  }

  get parentProductHandle () {
    return this?.dataset?.parentProductHandle
  }

  get storage () {
    return window.sessionStorage
  }

  get storageKey () {
    return 'complete-the-set'
  }
}

if (!customElements.get('complete-the-set')) {
  customElements.define('complete-the-set', CompleteTheSet)
}
